module.exports = __webpack_public_path__ + "static/media/poiissehotelblack.f0041e9a.png";